import { gql } from '@apollo/client';

// Hand-typed GraphQL operations for AI cover generation. There is no codegen
// for this feature — production introspection is disabled — so these types
// must be kept in exact sync with the backend SDL by hand:
//
//   enum CoverAspect { portrait landscape }
//   type AiCoverGeneration { id: ID!, processing_status: String!, result_url: String, error_code: String, aspect: CoverAspect!, createdAt: String }
//   type AiCoverQuota { used: Int!, limit: Int!, resets_at: String! }
//   generateMyCoverImage(clipId: ID!, prompt: String, referenceUrl: String, aspect: CoverAspect!): AiCoverGeneration!
//   myCoverGeneration(id: ID!): AiCoverGeneration
//   myCoverGenerationQuota: AiCoverQuota!

export type CoverAspect = 'portrait' | 'landscape';

/** `processing_status` values the backend can return. */
export type AiCoverProcessingStatus = 'pending' | 'processing' | 'done' | 'failed';

export interface AiCoverGeneration {
  id: string;
  processing_status: string;
  result_url: string | null;
  error_code: string | null;
  aspect: CoverAspect;
  createdAt: string | null;
}

export interface AiCoverQuota {
  used: number;
  limit: number;
  resets_at: string;
}

const AI_COVER_GENERATION_FIELDS = `
  id
  processing_status
  result_url
  error_code
  aspect
  createdAt
`;

export const GENERATE_MY_COVER_IMAGE = gql`
  mutation GenerateMyCoverImage($clipId: ID!, $prompt: String, $referenceUrl: String, $aspect: CoverAspect!) {
    generateMyCoverImage(clipId: $clipId, prompt: $prompt, referenceUrl: $referenceUrl, aspect: $aspect) {
      ${AI_COVER_GENERATION_FIELDS}
    }
  }
`;

export interface GenerateMyCoverImageData {
  generateMyCoverImage: AiCoverGeneration;
}

export interface GenerateMyCoverImageVars {
  clipId: string;
  prompt?: string | null;
  referenceUrl?: string | null;
  aspect: CoverAspect;
}

export const MY_COVER_GENERATION = gql`
  query MyCoverGeneration($id: ID!) {
    myCoverGeneration(id: $id) {
      ${AI_COVER_GENERATION_FIELDS}
    }
  }
`;

export interface MyCoverGenerationData {
  myCoverGeneration: AiCoverGeneration | null;
}

export interface MyCoverGenerationVars {
  id: string;
}

export const MY_COVER_GENERATION_QUOTA = gql`
  query MyCoverGenerationQuota {
    myCoverGenerationQuota {
      used
      limit
      resets_at
    }
  }
`;

export interface MyCoverGenerationQuotaData {
  myCoverGenerationQuota: AiCoverQuota;
}
